
import React from 'react';
import RestaurantListContainer from './restaurants/RestaurantListContainer';

const RestaurantList: React.FC = () => {
  return <RestaurantListContainer />;
};

export default RestaurantList;
